<div class="d-flex align-items-center py-3 py-md-0">
  <div class="container padding-bottom-3x euroFont">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10" *ngIf="(this.email=='' && this.confirmToken=='')">
        <div class="forgot">
          <h2>{{"Forgot-your-password" | translate}}?</h2>
          <p>{{"Change-password-step" | translate}}!</p>
          <ol class="list-unstyled">
            <li><span class="text-primary text-medium">1. </span>{{"step1" | translate}}</li>
            <li><span class="text-primary text-medium">2. </span>{{"step2" | translate}}</li>
            <li><span class="text-primary text-medium">3. </span>{{"step3" | translate}}</li>
          </ol>
        </div>
        <form class="card mt-4" [formGroup]="this.forgotForm">
          <div class="card-body">
            <div class="form-group row">
              <div class="col-md-12">
                <label for="email" class="dangerAstrick" translate>Enter-your-email-Id</label>
                <input type="email" formControlName="email" name="email" id="email" class="form-control"
                  placeholder="{{'Email-Id' | translate}}" [ngClass]="{ 'is-invalid': submitted && f?.email.errors }" maxlength="50">
                <div *ngIf="submitted && f?.email.errors" class="invalid-feedback">
                  <div *ngIf="f?.email.errors.required">{{"Email" | translate}} {{"Required" | translate}}</div>
                  <div *ngIf="f?.email.errors.email">Email {{"Must-be-a-valid-email-address" | translate}}</div>
                </div>
              </div>
            </div>
            <small class="form-text text-muted">{{"step4" | translate}}</small>
          </div>
          <div class="card-footer"> <button class="btn btn-primary" type="submit" appDebounceClick
              (debounceClick)="onGetPassword()"  translate>Get-New-Password</button> <button class="btn btn-secondary ml-2" type="submit"
              [routerLink]="['/Auth/Login']" translate>Back-to-Login</button> </div>
        </form>
      </div>

      <div class="col-lg-6 col-md-8" *ngIf="(this.email != '' && this.confirmToken != '')">
        <div class="card">
          <h3 class="mt-4 text-center" translate>
            Reset-your-password-and-get-login
          </h3>
          <form class="ml-4 mr-4 mt-4 mb-2" [formGroup]="this.pwdForm">
            <div class="form-group">
              <div class="col-md-12">
                <label for="email" class="dangerAstrick" translate>Enter-your-email-Id</label>
                <input type="email" formControlName="email" name="email" id="email" class="form-control"
                  placeholder="{{'Email-Id' | translate}}" [ngClass]="{ 'is-invalid': submitted && p?.email.errors }" maxlength="50"
                  readonly>
              </div>
            </div>
            <div class="form-group">
              <div class="col-md-12">
                <label for="password" class="dangerAstrick">{{"New-Password" | translate}}</label>
                <div class="input-group">
                  <input [type]="fieldTextType1 ? 'text' : 'password'" name="newPassword" formControlName="newPassword"
                    id="newPassword" class="form-control iconAdd" placeholder="***********"
                    [ngClass]="{ 'is-invalid': submitted && p?.newPassword.errors }">
                  <div class="input-group-append">
                    <span class="input-group-text iconBorder hoverCursor" (click)="toggleFieldTextType(1)">
                      <i class="fa" [ngClass]="{
              'fa-eye-slash': !fieldTextType1,
              'fa-eye': fieldTextType1
            }"></i>
                    </span>
                  </div>
                  <div *ngIf="submitted && p?.newPassword.errors" class="invalid-feedback">
                    <div *ngIf="p?.newPassword.errors.required">{{"New-Password" | translate}}
                      {{"Required" | translate}}
                    </div>
                    <div *ngIf="p?.newPassword.errors.minlength" translate>Password-must-be-at-least-6-characters</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mb-4">
              <div class="col-md-12">
                <label for="password dangerAstrick" class="dangerAstrick">{{"Confirm-New-Password" | translate}}</label>
                <div class="input-group">
                  <input [type]="fieldTextType2 ? 'text' : 'password'" name="confirmPassword"
                    formControlName="confirmPassword" id="confirmPassword" class="form-control iconAdd"
                    placeholder="***********" [ngClass]="{ 'is-invalid': submitted && p?.confirmPassword.errors }">
                  <div class="input-group-append">
                    <span class="input-group-text iconBorder hoverCursor" (click)="toggleFieldTextType(2)">
                      <i class="fa" [ngClass]="{
            'fa-eye-slash': !fieldTextType2,
            'fa-eye': fieldTextType2
          }"></i>
                    </span>
                  </div>
                  <div *ngIf="submitted && p?.confirmPassword.errors" class="invalid-feedback">
                    <div *ngIf="p?.confirmPassword.errors.required">{{"Confirm-New-Password" | translate}}
                      {{"Required" | translate}}</div>
                    <div *ngIf="p?.confirmPassword.errors.mustMatch" translate>Passwords-must-match</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer"> <button class="btn btn-primary" type="submit" appDebounceClick
                (debounceClick)="onResetPassword()" translate>Set-Password-to-go-Login</button></div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>
